// extracted by mini-css-extract-plugin
export var active = "styles-module__active___yoDpi";
export var explore = "styles-module__explore___ltHCu";
export var tab = "styles-module__tab___vkRk9";
export var tabBar = "styles-module__tabBar___hErm3";